// Retry configuration for service initialization and network operations
// Shared across all components that need retry functionality

export const RETRY_CONFIG = {
    maxRetries: 5, // Reduced from 10 - industry best practice for API retries
    baseDelay: 1000, // 1 second
    maxDelay: 30000, // 30 seconds
    backoffFactor: 1.5,
} as const;

export type RetryConfig = typeof RETRY_CONFIG;
